module.exports = __webpack_public_path__ + "static/media/map_bottom.45cd0876.png";